import React, {Component} from 'react';
import './background-video.css';

class BGVideo extends Component {
    constructor (props) {
        super(props);

        this.state = {
            videoURL: 'https://cdn.jwjb.io/surfside/video/home-1080'
        }
    }

    render () {
        return (
            <video id="background-video" loop autoPlay>
                <source src={this.state.videoURL + '.mp4'} type="video/mp4" />
                <source src={this.state.videoURL + '.webm'} type="video/webm" />
                Your browser does not support the video tag.
            </video>
        )
    }
};

export default BGVideo;


// WEBPACK FOOTER //
// ./src/components/background-video/background-video.js